/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useState } from 'react';
import './Contact.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faYoutube, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';
import { InfinitySpin } from 'react-loader-spinner'; // Importamos el spinner
 

function ContactContent() {
    const [loading, setLoading] = useState(false);
    const form = useRef();

    const handleButtonYoutube = () => {
        window.open('https://www.youtube.com/channel/UCTBxxvzMkx8iEwuDEitBP8g', '_blank');
    };

    const handleButtonClick = () => {
        window.open('https://www.linkedin.com/company/bccy-colombia/jobs/?viewAsMember=true', '_blank');
    };

    const handleWhatsappButtonClick = () => {
        const whatsappNumber = '3160267867';
        const message = encodeURIComponent('Hola, estoy interesado en contactarme contigo.');
        window.open(`https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${message}`, '_blank');
    };

    const iconStyle = { color: 'black' };

    const sendEmail = async (e) => {
        e.preventDefault();
        setLoading(true)
    
        const formData = {
            user_name: form.current.user_name.value,
            user_email: form.current.user_email.value,
            message: form.current.message.value,
            location: "Holding"
        };
    
        try {
            // const response = await fetch("http://localhost/bccy-backend/send_email.php", {
            const response = await fetch("https://bccycolombia.com/backend/send_email.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });
    
            const result = await response.json();
    
            if (result.status === "success") {
                toast.success("El correo se envió correctamente ✅");
                form.current.reset();
            } else {
                toast.error("Error al enviar el correo ❌");
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("Ocurrió un error ❌");
        } finally {
            setLoading(false); // Desactiva el spinner después de recibir la respuesta
        }
    };

    return (
        <div className="container1">
            <Toaster position="top-right" reverseOrder={false} />
            {loading && (
                <div className="loading-overlay">
                    <InfinitySpin width="200" color="#4890A0" />
                </div>
            )}

            <div className="box-info">
                <h1 className='h1contact'>CONTÁCTATENOS HOLDING</h1>
               <div className="data">
                    <p>
                        <FaPhone />
                        <span>
                            <strong>Línea de Atención</strong>
                            +57 601 756 9677
                        </span>
                    </p>
                    <p>
                        <FaEnvelope />
                        <span>
                            <strong>Información General</strong>
                            bccycolombia@bccynewpower.com
                        </span>
                    </p>
                    <p>
                        <FaEnvelope />
                        <span>
                            <strong>PQRSF</strong>
                            peticiones@bccynewpower.com
                        </span>
                    </p>
                    <p>
                        <FaMapMarkerAlt />
                        <span>
                            <strong>Sede principal — Bogotá, Colombia</strong>
                            Calle 113 # 7 - 21 Oficina 918
                        </span>
                    </p>
                </div>
                <div className="links">
                    <a onClick={handleButtonYoutube}><FontAwesomeIcon icon={faYoutube} style={iconStyle} /></a>
                    <a onClick={handleButtonClick}><FontAwesomeIcon icon={faLinkedin} style={iconStyle} /></a>
                    <a onClick={handleWhatsappButtonClick}><FontAwesomeIcon icon={faWhatsapp} style={iconStyle} /></a>
                </div>
            </div>

            <form ref={form} onSubmit={sendEmail} >
                <div className="input-box">
                    <input type="text" name="user_name" placeholder="Nombre y apellido" />
                </div>
                <div className="input-box">
                    <input type="email" name="user_email" placeholder="Correo electrónico" />
                </div>
                <div className="input-box">
                    <textarea name="message" placeholder="Escribe tu mensaje..." />
                </div>
                <button type="submit" disabled={loading}>
                    {loading ? "Enviando..." : "Enviar Mensaje"}
                </button>
            </form>
        </div>
    );
}

export default ContactContent;
